import styled from "styled-components";

export const StyledOptionLabel = styled.span`
  fontsize: 13px;
  color: #b2b2b3;
  fontweight: 500;
`;
